'use strict';

/**
 *
 * @name: nnCollapse
 *
 **/

function NnCollapseDirective() {

  'ngInject';

  return {
    restrict: 'A',
    controller: nnCollapseDirectiveController
  };
}

function nnCollapseDirectiveController(
  $timeout,
  $element,
  $parse,
  $attrs
) {

  'ngInject';

  /**
   *
   * @CONFIG
   *
   */

  var isCollapsed;

  /**
   *
   * @PRIVATE_METHODS
   *
   */

  function _init() {

    $element.addClass('nn-collapse');

    $timeout(function() {

      isCollapsed = _getIsCollapsed();

      switch (isCollapsed) {
        case true:

          $element.hide();
          break;

        case false:

          break;
      }

      _attrObserve();
    });
  }

  function _getIsCollapsed() {

    return ($attrs.nnCollapse === 'true');
  }

  function _attrObserve() {

    $attrs.$observe('nnCollapse', function() {

      isCollapsed = _getIsCollapsed();

      $($element).slideToggle();
    });
  }

  /**
   *
   * @INIT
   *
   */

  _init();
}

export default NnCollapseDirective;



// WEBPACK FOOTER //
// ./app/components/nn-generic-directives/nn-collapse.directive.js